import React, { useCallback, useMemo, useState } from "react";
import AtlasMap from "./atlas/AtlasMap";
import EvidencePanel from "./atlas/EvidencePanel";
import useAtlas from "./atlas/useAtlas";

// The section's front door, which is the web itself rather than an index of
// ways into it. It opens on whatever the most connected thing is, because that
// is the part of the map with the most to walk to.
export default function AtlasBrowser({ atlas: payload }) {
  const start = useMemo(() => {
    const degree = new Map();
    // Edges carry node indices, not keys — see CorrespondenceAtlasPayload.
    payload.edges.forEach((edge) => {
      degree.set(edge.f, (degree.get(edge.f) || 0) + 1);
      degree.set(edge.t, (degree.get(edge.t) || 0) + 1);
    });
    let best = null;
    degree.forEach((count, at) => {
      if (!best || count > best.count) best = { at, count };
    });
    return best === null ? undefined : payload.nodes[best.at]?.key;
  }, [payload.edges]);

  const [selected, setSelected] = useState(null);
  const atlas = useAtlas({
    focusKey: selected?.type === "node" ? selected.key : null,
    payload,
    start
  });

  const selectNode = useCallback((node) => {
    atlas.open(node.key);
    setSelected({ type: "node", key: node.key });
  }, [atlas]);

  const selectEdge = useCallback((edge) => setSelected({ type: "edge", id: edge.id }), []);

  if (payload.nodes.length === 0) return null;

  return (
    <div className="atlas-layout" data-testid="atlas-browser">
      <AtlasMap
        atlas={atlas}
        onSelectEdge={selectEdge}
        onSelectNode={selectNode}
        selected={selected}
      />
      <EvidencePanel
        atlas={atlas}
        onClose={() => setSelected(null)}
        onSelectEdge={selectEdge}
        onSelectNode={selectNode}
        schools={payload.schools}
        selected={selected}
      />
    </div>
  );
}
